import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type FloatingCtaProps = CtaShellProps

export function FloatingCta(props: FloatingCtaProps) {
	return <CtaShell {...props} placement="sticky" />
}